<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="剧本名称" prop="scriptId" >
                <a-select
                  show-search
                  placeholder="请选择剧本"
                  v-model="queryParam.scriptId"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  allow-clear
                >
                  <a-select-option v-for="(item) in this.playedScriptList" :value="item.scriptId" :key="item.scriptId">
                    {{ item.scriptName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="物料类型" prop="type">
                <a-select v-model="queryParam.type" placeholder="请选择物料类型" allow-clear>
                  <a-select-option :value="1">海报</a-select-option>
                  <a-select-option :value="2">文案</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="是否启用" prop="isActive">
                <a-select v-model="queryParam.isActive" placeholder="请选择是否启用" allow-clear>
                  <a-select-option :value="1">是</a-select-option>
                  <a-select-option :value="0">否</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" style="float: right">
              <span class="table-page-search-submitButtons" :style="{ float: 'right', overflow: 'hidden' }">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['played:script/material:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['played:script/material:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['played:script/material:remove']">
          <a-icon type="delete" />删除
        </a-button>
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['played:script/material:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <div slot="content" slot-scope="text, record">
          <img v-if="record.type === 1 && record.content" :src="record.content" style="width:100px; cursor: pointer;" preview alt=""/>
          <span
            v-if="record.type === 2"
            style="display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 300px;"
            :title="record.content"
          >{{ record.content }}</span>
        </div>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['played:script/material:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['played:script/material:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['played:script/material:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['played:script/material:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { listScriptMaterial, delScriptMaterial } from '@/api/played/scriptMaterial'
import { listScript } from '@/api/played/script'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import Dept from '@/views/system/dept/index.vue'

export default {
  name: 'ScriptMaterial',
  components: {
    Dept,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      playedScriptList: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        scriptId: undefined,
        type: undefined,
        content: undefined,
        sort: undefined,
        isActive: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        // {
        //   title: '物料ID',
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '剧本名称',
          dataIndex: 'scriptName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '物料类型',
          dataIndex: 'type',
          ellipsis: true,
          width: 120,
          align: 'center',
          customRender: (text) => {
            return { 1: '海报', 2: '文案' }[text]
          }
        },
        {
          title: '物料内容',
          dataIndex: 'content',
          scopedSlots: { customRender: 'content' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '排序',
          dataIndex: 'sort',
          ellipsis: true,
          width: 60,
          align: 'center'
        },
        {
          title: '是否启用',
          dataIndex: 'isActive',
          ellipsis: true,
          width: 120,
          align: 'center',
          customRender: (text) => {
            return { 0: '否', 1: '是' }[text]
          }
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
    listScript({ scriptName: this.queryParam.scriptName }).then(res => {
      this.playedScriptList = res.data
    })
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询银河打本剧本宣传物料列表 */
    getList () {
      this.loading = true
      listScriptMaterial(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        scriptId: undefined,
        type: undefined,
        content: undefined,
        sort: undefined,
        isActive: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          return delScriptMaterial(ids)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {}
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('played/script/material/export', {
            ...that.queryParam
          }, `script/material_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    }
  }
}
</script>
